import 'css-chunksrc/client/pages/projectPage/resourcesPage/resourcesList/contentLoader/styles.scss';export default {
  "iconSkeleton": "_iconSkeleton_1kos1_1",
  "textSkeleton": "_textSkeleton_1kos1_7",
  "resource": "_resource_1kos1_12",
  "contextualMenu": "_contextualMenu_1kos1_18",
  "user": "_user_1kos1_31",
  "tagsList": "_tagsList_1kos1_45",
  "avatar": "_avatar_1kos1_54",
  "roleSelection": "_roleSelection_1kos1_66",
  "name": "_name_1kos1_75",
  "nameSkeleton": "_nameSkeleton_1kos1_82",
  "professionSkeleton": "_professionSkeleton_1kos1_87",
  "tags": "_tags_1kos1_45",
  "tagSkeleton": "_tagSkeleton_1kos1_101"
};